<template>
<v-app>
  <v-main>
    <v-container class="fill-height elevation-12" fluid>
      <m-globals/>

      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="6">

          <v-alert
            type="info"
            dismissible
            v-if="in_private_browsing_mode"
          >
            <p>Your browser is in {{$rc.getNameOfPrivateBrowsingMode()}} mode.</p>
            
            <p>If you do not want to have to sign in to RedChirp every time you use it, <b>you must exit {{$rc.getNameOfPrivateBrowsingMode()}} mode.</b></p>
          </v-alert>

          <v-card class="mx-auto mt-5">
            <v-toolbar color="primary" dark flat>
            <v-toolbar-title>RedChirp Sign In</v-toolbar-title>
            </v-toolbar>
            <v-card-text>

              <v-alert 
                v-model="alert_visible" 
                type="error" 
                dismissible
                color="primary"
              >
                {{ alert_text }}
              </v-alert>
              
              <v-form>
                <v-text-field 
                  v-model="username" 
                  prepend-icon="mdi-account-circle" 
                  label="Email Address"
                  ref="username" 
                  v-on:keyup.native.enter="onUsernameEnter"
                  autofocus
                  type="email"
                />

                <v-text-field
                  v-model="password"
                  prepend-icon="mdi-lock"
                  label="Password"
                  ref="password"
                  :append-icon="password_append_icon"
                  :type="password_type"
                  v-on:click:append="onTogglePasswordVisible"
                />

                <m-sign-in-totp
                  :username="username"
                  :is_valid.sync="is_totp_valid"
                  :totp_setup_qr_code.sync="totp_setup_qr_code"
                  style="margin-left: 35px; margin-bottom: 15px;"
                  v-model="otp"
                />

                <p
                  style="margin-bottom: 10px"
                >

                  <a 
                    style="padding-left: 30px"
                    v-on:click="onClickSignInForTheFirstTime"  
                  >
                    Sign in for the first time...
                  </a>
                </p>

                <p
                  style="margin-bottom: 10px"
                >
                  <a 
                    style="padding-left: 30px"
                    v-on:click="onForgotPassword"
                  >
                    Forgot password?
                  </a>
                </p>

                <p
                  style="margin-bottom: 10px"
                >
                  <a 
                    style="padding-left: 30px"
                    v-on:click="$rc.contactSupport('Sign In')"
                  >
                    Need help?  Click here to contact RedChirp support.
                  </a>
                </p>

              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn 
                color="primary" 
                v-on:click="doSignIn"
                style="margin-right: 15px; margin-bottom: 15px"
                :disabled="!is_valid"
              >
                Sign In
              </v-btn>
            </v-card-actions>
          </v-card>

          <div
            style="margin-top: 15px; text-align: right"
            v-if="show_add_to_home_screen"
          >
            <a 
              v-on:click="onClickAddToHomeScreen"
              style="text-decoration: underline;"
            >
              Add RedChirp to your home screen
            </a>    
          </div>

    

        </v-col>
      </v-row>
    </v-container>

  </v-main>
</v-app>
</template>

<script>

const Preconditions = require("@/js/Preconditions.js");


  export default {
    data() {
      return {
        username: '',
        password: '',
        alert_visible: false,
        alert_text: null,
        password_visible: false,
        in_private_browsing_mode: false,
        show_add_to_home_screen: false,
        show_otp: false,
        otp: null,
        is_totp_valid: false,
        totp_setup_qr_code: null,
      }
    },

    created () {
      this.$event_bus.$on('rc_device_fingerprint', this.onFingerPrintUpdated);
    },

    beforeDestroy () {
      this.$event_bus.$off('rc_device_fingerprint',this.onFingerPrintUpdated);
    },

    mounted () 
    {
       if ( Preconditions.isNull(this.$route.query.username) )
        {
            this.username = '';
        }
        else
        {
            this.username = this.$route.query.username;
        }

        this.onFingerPrintUpdated(); // set everything to its starting value
    },
    methods: 
    {
      doSignIn()
      {
        this.$rc.rest({
          'spinner': true,
          'endpoint': 'POST: /api/v1/auth/sign-in',
        
          'params' : {
              'username': this.username,
              'password': this.password,
              'otp': this.otp,
              'totp_setup_qr_code': this.totp_setup_qr_code,
            },
        
          'on_success': (data) => {
                this.$rc.updateProfile(data);

                let front_end_link_id = localStorage.getItem('rc_after_sign_in_front_end_link_id');
                let rc_after_sign_in_url = localStorage.getItem('rc_after_sign_in_url');

                this.clearAfterSignInUrl();

                if ( rc_after_sign_in_url != null )
                {
                  window.location = rc_after_sign_in_url;
                  return;
                }

                if ( front_end_link_id != null )
                {
                  this.$router.push({
                    'name': 'short_link_router',
                    'params' : {
                      'front_end_link_id' : front_end_link_id
                    }
                  });

                  return;
                }
                
                this.$router.push({name: 'home' });
            },
        
          'on_error': () => {
            this.$rc.updateProfile({});
            this.alert_text = "Unable to sign in, check your username and password.";
            this.alert_visible = true;
          },
        });
      },

      onFingerPrintUpdated()
      {
        this.in_private_browsing_mode = this.$rc.inPrivateBrowsingMode();
        this.show_add_to_home_screen = this.$rc.offerAddToHomeScreen();
      },

      clearAfterSignInUrl()
      {
        window.localStorage.removeItem('rc_after_sign_in_url');
      },

      onForgotPassword()
      {
        this.clearAfterSignInUrl();
        this.$router.push({name: 'start-reset-password', query: { 'username': this.username, 'action': 'reset' }});
      },

      onClickSignInForTheFirstTime()
      {
        this.clearAfterSignInUrl();
        this.$router.push({name: 'start-reset-password', query: { 'username': this.username, 'action': 'create' }});
      },

      onTogglePasswordVisible()
      {
        this.password_visible = !this.password_visible;
      },

      onUsernameEnter()
      {
        this.$refs.password.focus();
      },

      onClickAddToHomeScreen()
      {
        this.$router.push({
          'name': 'ios-to-instructions',
        });
      },

      
    },
    
    computed: {
      password_append_icon(){
        if ( this.password_visible )
          return "mdi-eye-off";
        
        return "mdi-eye";
      },

      password_type(){
        if ( this.password_visible )
          return "text";

        return "password";
      },

      is_valid() {
        if ( !this.is_totp_valid ) return false;
        if ( (this.username ?? '').trim().length == 0 ) return false;
        if ( (this.password ?? '').trim().length == 0 ) return false;

        return true;
      },

     
    },
  }
</script>

<style lang="scss" scoped>
</style>